import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { environment } from '../../../../../environments/environment';
import { AlertsService } from '../../../../shared/service/alerts.service';
import { SocketService } from '../../../../shared/service/socket.service';
import { AuthService } from '../../../../core/service/auth.service';
declare var $
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  form: UntypedFormGroup;
  trackingForm: UntypedFormGroup;
  forgetPw: UntypedFormGroup;
  getEmail: UntypedFormGroup;
  trackingData = [];;
  constructor(private socket: SocketService, private formBuilder: UntypedFormBuilder, private router: Router, private alert: AlertsService, private api: AuthService) {
    let tokenData = localStorage.getItem(environment.tokenKey);
    if (tokenData) {
      this.router.navigate(['/map']);
    }
    else {
      return;
    }
  }

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.form = new UntypedFormGroup(
      {
        email: new UntypedFormControl("", Validators.pattern(/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i)),
        password: new UntypedFormControl("", Validators.required)
      })

    this.trackingForm = new UntypedFormGroup(
      {
        tripID: new UntypedFormControl("", Validators.required),
        truckNo: new UntypedFormControl("", Validators.required),
        permitNo: new UntypedFormControl("", Validators.required),
      })
    this.forgetPw = new UntypedFormGroup(
      {
        otp: new UntypedFormControl('', [Validators.required]),
        newPassword: new UntypedFormControl("", [Validators.required,
        Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,}$)/)]),
        confrmPassword: new UntypedFormControl("", [Validators.required,]),
      });

    this.getEmail = new UntypedFormGroup({
      email: new UntypedFormControl('', [Validators.required, Validators.pattern(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)]),
    })


    this.alert.detectFormChanges(this.form);

    this.alert.detectFormChanges(this.trackingForm);
  }

  showPswd() {
    var x = document.getElementById("password") as HTMLInputElement;
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
  }
  authError = false;
  authErrorMsg: string;

  login() {
    this.submitted = true;
    let { email, password } = this.form.value;
    if (email && password) {
      this.api.login({ email, password }).subscribe((res: any) => {
        const { success, token, message } = res
        if (success) {
          this.alert.loader().then((result) => {
            localStorage.setItem(environment.tokenKey, token);
            this.router.navigate(['/map']);
            var tokn = JSON.parse(atob((localStorage.getItem(environment.tokenKey)).split('.')[1])).token;
            tokn["iat"] = JSON.parse(atob((localStorage.getItem(environment.tokenKey)).split('.')[1])).iat;
            this.socket.connectSocket(tokn);
            this.socket.getSocketID()
          })
            .catch((err) => {
              this.authError = true;
              this.authErrorMsg = err.message;
              this.alert.showToast(err.message, 'error')
            });
        }
        else {
          this.alert.showToast(message, 'error')
        }
      }, (err) => this.alert.showToast(err.message, 'error'))
    }
    else {

    }
  }

  isGetOtp: boolean = false;
  isPwMatched: boolean = false;
  otp = '';
  resetPassword() {
    let obj = {
      "otp": this.forgetPw.value.otp,
      "newpassword": this.forgetPw.value.newPassword,
      "email": this.getEmail.value.email,
    } 
    // this.api.resetPassword(obj).subscribe((res: any) => { 
    //   if (res.success) {
    //     $("#forgetPw").modal('hide');
    //     this.isGetOtp = false;
    //     this.alert.showToast(res.message, "success")
    //     this.getEmail.reset();
    //     return true;
    //   } else {
    //     this.alert.showToast(res.message, "error")
    //   }
    // })
  }

  getOTP() { 
    // this.isGetOtp = true;
    // this.router.navigate(['/forget'])
    this.api.forgotPassword({ email: this.getEmail.value.email }).subscribe((res: any) => {
      if (res.success) {
        // this.isGetOtp = true;
        $("#forgetPw").modal('hide');
        this.alert.showToast(res.message, "success")
      } else {
        this.alert.showToast(res.message, "error")
      }
    })
  }

  // Function to check Whether both passwords is same or not.
  checkPassword(val) {
    let ConfrmPw = val.target.value;
    let password1 = this.forgetPw.value.newPassword;
    if (password1 === ConfrmPw) { 
      this.isPwMatched = true;
    } else { 
      this.isPwMatched = false;
      // return false;
    }
  }
  submitted = false;
  errorMessage = '';
  loginOtp(param1?) {
    this.otp = '';
    let { email, password, userType } = this.form.value;
    // this.api.loginOtp({ email, userType }).subscribe((res: any) => {
    //   const { success, token, message } = res
    //   if (success) {
    //     this.alert.showToast(res.message, 'success');
    //     if (param1 != 'resend') {
    //       document.getElementById('verify').click();
    //     }
    //   } else {
    //     this.alert.showToast(res.message, 'error');
    //   }
    // })
  }


  trackNow() {
    this.trackingData = [];
    this.api.trackTruck(this.trackingForm.value).subscribe((res: any) => {
      const { success, trip, message } = res
      if (success) {
        this.trackingData = trip;
      }
      else {
        this.alert.showToast(message, 'error')
      }
    }, (err) => this.alert.showToast(err.message, 'error'))
  }

  reset() {
    this.trackingData = [];
    this.trackingForm.reset()
  }

  goToTrack(d) {
    window.open(`/tracking/?tripID=${d.tripID}&id=${d.device.id}`, '_blank')
  }



  // only for numeric value
  public restrictNumeric(e) {
    let input;
    if (e.metaKey || e.ctrlKey) {
      return true;
    }
    if (e.which === 32) {
      return false;
    }
    if (e.which === 0) {
      return true;
    }
    if (e.which === 46) {
      return false;
    }
    if (e.which < 33) {
      return true;
    }
    input = String.fromCharCode(e.which);
    return !!/[\d\.\s]/.test(input);
  }

}

